/* src/app/vehicle/pages/vehicle-edit/vehicle-edit.component.scss */
/*# sourceMappingURL=vehicle-edit.component.css.map */
